import { createBrowserHistory, Location } from 'history';

export const appHistory = createBrowserHistory();

let currentLocation = appHistory.location;
let previousAppLocation: Location | undefined;

appHistory.listen((location, action) => {
  if (action === 'PUSH') previousAppLocation = currentLocation;
  else if (action === 'POP') previousAppLocation = undefined;
  currentLocation = location;
});

export function getPreviousAppLocation() {
  return previousAppLocation;
}
